<template>
  <div class="section-panel text-center">
    <div class="title">
      <h3>{{$t('profile.title')}}</h3>
    </div>
    <el-container style="border: 1px solid #eee">
        <el-aside>
          <el-menu :default-active="idxActive" @select="setItem2">
            <el-menu-item index="1" class="text-left">
              <template slot="title">
                <i class="el-icon-user"></i> {{$t('profile.profile')}}
              </template>
            </el-menu-item>
            <el-menu-item index="2" class="text-left">
              <template slot="title"><i class="el-icon-lock"></i>{{$t('profile.password')}}</template>
            </el-menu-item>
            <el-menu-item index="3" class="text-left">
              <template slot="title"><i class="el-icon-key"></i>{{$t('profile.signature')}}</template>
            </el-menu-item>
          </el-menu>
        </el-aside>
        
        <el-container>
          <el-main>
            <span v-if="loading"><square-grid background="#FFFFFF"></square-grid> Loading...</span>
            <alert v-if="success" type="success" dismissible>
                {{success.message}}
            </alert>
            <span v-if="error">
              <alert type="danger" dismissible>
                  {{error.message}}
              </alert>
            </span>
            <div class="card plain" v-if="active=='information'">
              <div class="card-body p-4">
                <div class="photo-container">
                  <el-upload
                    class="avatar-uploader"
                    :action="uploadThumbnail"
                    :on-success="handleFileSuccess"
                    :headers = "header"
                    :data = "data"
                    name = "files"
                    :show-file-list="false"
                    list-type="picture-card">
                      <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>

                <h4>{{$t('profile.profile')}}</h4>
                <div class="row">
                  <div class="col-md-3">
                  </div>
                  <div class="col-md-6">
                    <form id="form-profile" role="form" @submit.prevent="onProfileSubmit">
                      <fg-input
                        class="no-border input-lg"
                        addon-left-icon="now-ui-icons"
                        placeholder="Name"
                        v-model="formProfile.name"
                      ></fg-input>
                      <fg-input
                        class="no-border input-lg"
                        addon-left-icon="now-ui-icons"
                        placeholder="Email"
                        :disabled="true"
                        v-model="formProfile.email"
                      ></fg-input>
                      <fg-input
                        class="no-border input-lg"
                        addon-left-icon="now-ui-icons"
                        placeholder="RFC"
                        v-model="formProfile.rfc"
                      >
                      </fg-input>
                      <fg-input
                        class="no-border input-lg"
                        addon-left-icon="now-ui-icons"
                        placeholder="Adress"
                        v-model="formProfile.address"
                      >
                      </fg-input>
                      <fg-input
                        class="no-border input-lg"
                        addon-left-icon="now-ui-icons"
                        placeholder="Phone number"
                        v-model="formProfile.phone"
                      >
                      </fg-input>
                      
                      <n-switch
                          v-model="formProfile.qualify"
                          :on-text="$t('profile.qualify_yes')"
                          :off-text="$t('profile.qualify_no')"
                        ></n-switch>
                        {{$t('profile.qualify')}}
                      <div class="card-footer text-center">
                        <n-button class="btn btn-primary btn-round btn-lg" type="secondary" native-type="submit">
                          {{$t('profile.button_profile')}}
                        </n-button>
                      </div>
                    </form>
                  </div>
                  <div class="col-md-3">
                  </div>
                </div>

              </div>
            </div>

            <div class="card plain" v-if="active=='security'">
              <div class="card-body p-4">
                <h4>{{$t('profile.title_1')}}</h4>
                <div class="row">
                  <div class="col-md-3">
                  </div>
                  <div class="col-md-6">
                    <span>Ingresa los datos, si deseas cambiar tu contraseña</span>
                    <br>
                    <br>
                    <form id="form-password" role="form" @submit.prevent="onPasswordSubmit">
                      <fg-input
                        class="no-border input-lg"
                        addon-left-icon="now-ui-icons objects_key-25"
                        placeholder="Password"
                        v-model="formPassword.password"
                        type="password"
                      ></fg-input>
                      <fg-input
                        class="no-border input-lg"
                        addon-left-icon="now-ui-icons objects_key-25"
                        placeholder="Password Confirm"
                        type="password"
                        v-model="formPassword.password_confirm"
                      ></fg-input>
                      <div class="card-footer text-center">
                        <n-button class="btn btn-primary btn-round btn-lg" type="secondary" native-type="submit">
                          {{$t('profile.button_change')}}
                        </n-button>
                      </div>
                    </form>
                  </div>
                  <div class="col-md-3">
                  </div>
                </div>
              </div>
            </div>

            <div class="card plain" v-if="active=='signature'">
              <div class="card-body p-4">
                <h4>{{$t('profile.title_2')}}</h4>
                <div class="row">
                  
                  <div class="col-md-3">
                  </div>
                  <div class="col-md-6">
                    <span>La firma digital es indispensable para poder invertir en las ofertas disponibles</span>
                    <br>
                    <form id="form-signarue" role="form" @submit.prevent="onSignatureSubmit">
                        <div class="card-footer text-center">
                          <fg-input
                            class="no-border input-lg"
                            addon-left-icon="now-ui-icons objects_key-25"
                            disabled
                          ></fg-input>

                          <n-button class="btn btn-primary btn-round btn-lg" type="secondary" native-type="submit">
                            {{$t('profile.button_signature')}}
                          </n-button>
                        </div>
                      </form>
                  </div>
                  <div class="col-md-3">
                  </div>
                </div>
              </div>
            </div>
          </el-main>
        </el-container>
      </el-container>
  </div>
</template>
<script>
import { Card, FormGroupInput, Button, Alert, Switch } from '@/components';
import {RotateSquare2, SquareGrid} from 'vue-loading-spinner'
import { Upload, Main, Header, MenuItem, Aside, Menu, MenuItemGroup, Container } from 'element-ui';
import Profile from '@/providers/Profile'
const ProfileProvider = new Profile()

export default {
  name: 'profile',
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    RotateSquare2,
    [Switch.name]: Switch,
    SquareGrid,
    Alert,
    [Container.name]: Container,
    [Main.name]: Main,
    [Header.name]: Header,
    [MenuItem.name]: MenuItem,
    [Aside.name]: Aside,
    [Menu.name]: Menu,
    [MenuItemGroup.name]: MenuItemGroup,
    [Upload.name]: Upload
  },
  data() {
    return {
        loading: false,
        error: null,
        success: null,
        active: 'information',
        formPassword: {
          password: null,
          password_confirm: null
        },
        formProfile: {
          id:null,
          name: null,
          email: null,
          address: null,
          qualify: null,
          rfc: null,
          phone: null,
          file_id: null,
          deleteFile: null
        },
        formSignature: {
          
        },
        imageUrl: '',
        idxActive: '1',
        key: null
     }
  },
  created() { 
    this.active = 'information'
    let id = this.$store.state.user.id
    ProfileProvider.getProfile(id).then(resp => {
        let attributes = resp.data.data.attributes
        let profile = {
          id: resp.data.data.id,
          name: attributes.name,
          rfc: attributes.rfc,
          email: attributes.email,
          phone: attributes.phone,
          address: attributes.address,
          file_id: attributes.file_id,
          deleteFile: null
        }
        this.formProfile = profile;
        if(attributes.img_profile && attributes.img_profile != "") {
          this.key = attributes.img_profile
          this.imageUrl = this.$store.state.api_files + this.key
        }
    });
  },
  computed: {
    header () {
      return {
        Authorization: this.$store.state.token
      }
    },
    uploadThumbnail () {
      return `${this.$store.state.api_files}upload`
    },
    data() {
      return { type: 'avatar' }
    }
  },
  methods: {
    setItem (item) {
      switch (item) {
        case "information":
          this.idxActive = '1'
        break;
        case "security":
          this.idxActive = '2'
        break;
        case "signature":
          this.idxActive = '3'
        break;
        default :
          this.idxActive = '1'
        break;
      }
      this.active = item
    },
    setItem2(idx) {
      switch (idx) {
        case '1':
          this.active = 'information'
        break;
        case "2":
          this.active = 'security'
        break;
        case "3":
          this.active = 'signature'
        break;
        default :
          this.active = 'information'
        break;
      }
    },
    isActive: function (l) {
      return this.active === l
    },
    onPasswordSubmit () {
      this.loading = true
      ProfileProvider.changePassword(this.formProfile.id, this.formPassword).then((resp)=> {
        this.loading = false
        this.error = null
        this.success = {
            message: "Password changed successful!"
        }
      }).catch((err)=>{
        this.loading = false
        this.error = {
            message: "Error comunication"
        }
      })
    },
    onProfileSubmit () {
      this.loading = true
      ProfileProvider.update(this.formProfile.id, this.formProfile).then((resp)=> {
        this.loading = false
        this.error = null
        this.success = {
            message: "Profile saved successful!"
        }
      }).catch((err)=>{
        this.loading = false
        this.error = {
            message: "Error comunication"
        }
      })
    },
    onSignatureSubmit () {
      this.loading = true
      ProfileProvider.signature(this.formProfile.id, this.formSignature).then((resp)=> {
        this.loading = false
        this.error = null
        this.success = {
            message: "Signature generated successful!"
        }
      }).catch((err)=>{
        this.loading = false
        this.error = {
            message: "Error comunication"
        }
      })
    },
    handleFileSuccess (res, file) {
      if(this.formProfile.file_id && this.key)
      {
        this.formProfile.deleteFile = [{
          id: this.formProfile.file_id,
          key: this.key,
        }]
      }
      this.imageUrl = URL.createObjectURL(file.raw);
      this.formProfile.file_id = file.response.data.id
    }
  }
};
</script>
<style>
</style>